import { useProject } from '../project-hooks/useProject';
import styles from './birthday-banner.module.less';
import { useSelector } from 'react-redux';
import { getPublishedRewardsForProject } from '../projects-reducer';
import { mapToHtml } from './birthday-banner-model';

const BirthdayBanner = () => {
    const project = useProject();
    const rewards = useSelector((state) => getPublishedRewardsForProject(state, project?.id));

    const birthdayRewards = rewards?.filter((r) => r.profile?.birthdayReward);

    if (!birthdayRewards?.length) {
        return null;
    }

    const mappedRewards = mapToHtml(birthdayRewards);

    return (
        <div className={styles.container}>
            <div className={styles.heading}>Gavebord</div>
            <div className={styles.giftWrapper}>{mappedRewards}</div>
        </div>
    );
};

export default BirthdayBanner;
